import {
    Box,
    Popover,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';


function WorkTimeModelPopover({ open, anchorEl, onClose, anchorOrigin }) {
    const { t } = useTranslation();

    return (
        <>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={anchorOrigin}
            >
                <Box sx={{ p: '10px', width: '500px', gap: 5 }}>
                    <Typography sx={{ pb: 1 }}>
                        {t('fuerHiwis', { ns: 'workTimeModel', defaultValue: "Für studentische Hilfskräfte:" })}
                    </Typography>
                    <Typography>
                        {t('noWorkTimeModel', {
                            ns: 'workTimeModel',
                            defaultValue: "Üblicherweise sind im Arbeitsvertrag deine Monatsstunden ohne festes Arbeitszeitmodell festgelegt. Trage entsprechend den Tagesdurchschnitt für deine Soll-Stunden ein (wie in CATS):"
                        })}                        
                    </Typography>
                    <Box sx={{ fontWeight: 'light', fontStyle: 'italic', ml: 3, py: 1 }}>
                        <Typography >
                            {t('weeklyHours', { ns: 'workTimeModel', factor: '4,35',  defaultValue: "Wochenstunden = Monatsstunden / {{factor}}" })}
                        </Typography>
                        <Typography>
                            {t('dailyHours', { ns: 'workTimeModel', factor: '21,75', defaultValue: "Tagesdurchschnitt = Monatsstunden / {{factor}}." })}
                        </Typography>
                    </Box>
                    <Typography>
                        {t('formloseAbsprachen', {
                            ns: 'workTimeModel',
                            defaultValue: "Formlose Absprachen mit deinen Betreuenden, auf welche Wochentage du Arbeitstage legst, sind nicht gemeint."
                        })}                         
                    </Typography>
                </Box>
            </Popover>
        </>
    );
};

export default WorkTimeModelPopover
